<template>
  <th class="data-table-header-cell">
    <div class="data-table-divider" />
    <slot />
  </th>
</template>

<style>
th.data-table-header-cell {
  border: none;
}
.data-table-divider {
  display: inline;
  padding: 0;
  margin: 0px 4px 0px -2px;
  border-left: 1px solid #DDDDDD;
}
.table > thead > tr.data-table-top-header > th:first-child > .data-table-divider {
  display: none;    
}
</style>

<script>
export default {
  name: 'DataTableHeaderCell'
}
</script>